import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { AccountSandbox } from "src/core/account/account.sandbox";
import { UserModel } from "src/core/account/models/registerUser.model";
import { CortizoUserModel } from "src/core/account/models/user.model";
import { MessageService } from "src/core/services/messages.service";

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    templateUrl: './edit-user.dialog.html',
    styleUrls: ['./edit-user.dialog.scss']
})
export class EditUserDialogComponent implements OnDestroy, OnInit {
    private subs: Subscription[] = [];

    form: FormGroup;
    phone: FormControl = new FormControl('');
    email: FormControl = new FormControl('', [Validators.email]);
    is_active: FormControl = new FormControl(false);
    blocked: FormControl = new FormControl(false);
    name: FormControl = new FormControl('');
    company_name: FormControl = new FormControl('');
    area: FormControl = new FormControl('');

    matcher = new MyErrorStateMatcher();

    constructor(
        public accountSandbox: AccountSandbox,
        private fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: CortizoUserModel,
        private message: MessageService,
        private dialogRef: MatDialogRef<EditUserDialogComponent>
    ) {
        this.accountSandbox.doClearUpdateUserItemState();
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            phone: this.phone,
            email: this.email,
            is_active: this.is_active,
            blocked: this.blocked,
            name: this.name,
            company_name: this.company_name,
            area: this.area
        })

        this.pathEditedData();

        this.subs.push(this.accountSandbox.updateUserItemData$.subscribe(res => {
            if (res) {
                this.dialogRef.close(true);
            }
        }))
        this.subs.push(this.accountSandbox.updateUserItemFailData$.subscribe(res => {
            if (res) {
                this.message.log('Server error!');
            }
        }))
    }

    private pathEditedData(): void {
        if (this.data) {
            this.phone.patchValue(this.data.phone);
            this.email.patchValue(this.data.email);
            this.is_active.patchValue(this.data.is_active);
            this.blocked.patchValue(this.data.blocked);
            this.name.patchValue(this.data.name);
            this.company_name.patchValue(this.data.company_name);
            this.area.patchValue(this.data.area);
        }
    }

    submit(): void {
        if (this.form.invalid && this.data && this.data.id) {
            this.message.log('Invalid data!');
            return;
        }

        const params: any = {
            phone: this.phone.value,
            email: this.email.value,
            is_active: this.is_active.value,
            blocked: this.blocked.value,
            name: this.name.value,
            company_name: this.company_name.value,
            area: this.area.value
        }
        this.accountSandbox.doUpdateUserItem(this.data.id, params);
    }

    ngOnDestroy(): void {
        this.subs.map(s => s.unsubscribe());
    }
}

